import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useLocation, Link } from 'react-router-dom';
import { LayoutProps } from '../types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faBuilding, faUser, faUsers, faMobile, faKey, faTachometerAlt, faUserCheck, faBook } from '@fortawesome/free-solid-svg-icons';

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const handleLogout = (): void => {
    logout();
  };

  const isActive = (path: string): boolean => {
    return location.pathname === path;
  };

  const getInitials = (name?: string): string => {
    if (!name) return 'U';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  return (
    <div className="dashboard-container">
      {/* Sidebar */}
      <div className="sidebar">
        <div className="sidebar-header">
          <div className="logo">
            <div className="logo-icon">Z</div>
            ZeaOne
          </div>
        </div>
        
        <nav className="sidebar-nav">
          <Link to="/dashboard" className={`nav-item ${isActive('/dashboard') ? 'active' : ''}`}>
            <FontAwesomeIcon icon={faTachometerAlt} className="nav-icon" />
            Dashboard
          </Link>
          {user?.role === 'super_admin' && (
            <Link to="/organizations" className={`nav-item ${isActive('/organizations') ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faBuilding} className="nav-icon" />
              Organizations
            </Link>
          )}
          {user?.role === 'super_admin' && (
            <Link to="/users" className={`nav-item ${isActive('/users') ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faUser} className="nav-icon" />
              User Management
            </Link>
          )}
          {user?.role === 'organization_admin' && (
            <Link to="/my-organization" className={`nav-item ${isActive('/my-organization') ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faBuilding} className="nav-icon" />
              My Organization
            </Link>
          )}
          {user?.role === 'organization_admin' && (
            <Link to="/my-users" className={`nav-item ${isActive('/my-users') ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faUsers} className="nav-icon" />
              My Users
            </Link>
          )}
          {(user?.role === 'organization_admin' || user?.role === 'organization_user') && (
            <Link to="/user-purchases" className={`nav-item ${isActive('/user-purchases') ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faUserCheck} className="nav-icon" />
              Subscriptions
            </Link>
          )}
          {(user?.role === 'organization_admin' || user?.role === 'organization_user') && (
            <Link to="/applications" className={`nav-item ${isActive('/applications') ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faMobile} className="nav-icon" />
              Applications
            </Link>
          )}
          {(user?.role === 'organization_admin' || user?.role === 'organization_user') && (
            <Link to="/api-keys" className={`nav-item ${isActive('/api-keys') ? 'active' : ''}`}>
              <FontAwesomeIcon icon={faKey} className="nav-icon" />
              API Keys
            </Link>
          )}
          <Link to="/profile" className={`nav-item ${isActive('/profile') ? 'active' : ''}`}>
            <FontAwesomeIcon icon={faUser} className="nav-icon" />
            Profile
          </Link>
          <a href="/docs" className={`nav-item ${isActive('/docs') ? 'active' : ''}`} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faBook} className="nav-icon" />
            Documentation
          </a>
        </nav>

      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Header */}
        <header className="header">
          <div className="header-left">
            <h1 style={{ margin: 0, fontSize: '20px' }}>ZeaOne Admin Dashboard</h1>
          </div>
          <div className="header-right">
            <div className="user-info">
              <div className="user-avatar">
                {getInitials(user?.username)}
              </div>
              <span>{user?.username}</span>
              <button 
                onClick={handleLogout}
                style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: '#dc2626',
                  border: '2px solid white',
                  borderRadius: '8px',
                  color: 'white',
                  padding: '0',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  cursor: 'pointer',
                  overflow: 'hidden',
                  minWidth: '100px'
                }}
                title="Logout"
              >
                <div style={{
                  backgroundColor: '#dc2626',
                  padding: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRight: '1px solid rgba(255,255,255,0.3)'
                }}>
                  <FontAwesomeIcon icon={faSignOutAlt} style={{ fontSize: '14px' }} />
                </div>
                <div style={{
                  padding: '8px 12px',
                  flex: 1,
                  textAlign: 'center'
                }}>
                  LOGOUT
                </div>
              </button>
            </div>
          </div>
        </header>

        {/* Content Area */}
        <div className="content-area">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
